import Finish from '../../ESignature/Finish';
import { TaskCreateModalProps } from '../type';
import {
  BindingStatus,
  CreateTaskStatus,
  TaskType,
} from '@admiin-com/ds-graphql';
import { t } from 'i18next';
import { useMemo } from 'react';
import { useTaskCreationContext } from '../../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const Finished = ({
  setPage,
  taskDirection,
  createdTask,
  onClose,
  isEditing,
  taskType,
  isBinding,
  binding,
}: TaskCreateModalProps) => {
  const { resetForm } = useTaskCreationContext();
  const title = useMemo(() => {
    if (taskType === 'tax') {
      if (
        binding?.status === BindingStatus.DRAFT ||
        (!binding?.status && createdTask?.status === CreateTaskStatus.DRAFT)
      ) {
        return t('taxDraftCreatedTitle', { ns: 'taskbox' });
      }
      if (binding?.status === BindingStatus.REVIEW) {
        return t('taxReviewCreatedTitle', { ns: 'taskbox' });
      }
      if (
        binding?.status === BindingStatus.SENT ||
        (!binding?.status && isBinding)
      ) {
        return t('documentSentToClient', { ns: 'taskbox' });
      }
      if (createdTask?.status === CreateTaskStatus.REVIEW) {
        return t('taxReviewCreatedTitle', { ns: 'taskbox' });
      }
      if (isEditing) {
        return t('documentSentToClient', { ns: 'taskbox' });
      }
      return t('documentSentToClient', { ns: 'taskbox' });
    }
    if (createdTask?.status === CreateTaskStatus.DRAFT) {
      return t('draftCreatedTitle', { ns: 'taskbox' });
    }
    if (taskDirection === 'SENDING') {
      return t('documentSent', { ns: 'taskbox' });
    }
    return t('documentCreated', { ns: 'taskbox' });
  }, [
    binding?.status,
    createdTask?.status,
    isBinding,
    isEditing,
    taskDirection,
    taskType,
  ]);

  const description = useMemo(() => {
    if (taskType === 'tax') {
      if (
        binding?.status === BindingStatus.DRAFT ||
        (!binding?.status && createdTask?.status === CreateTaskStatus.DRAFT)
      ) {
        return t('taxDraftCreatedDescription', { ns: 'taskbox' });
      }
      if (binding?.status === BindingStatus.REVIEW) {
        return t('taxReviewCreatedDescription', { ns: 'taskbox' });
      }
      if (
        binding?.status === BindingStatus.SENT ||
        (!binding?.status && isBinding)
      ) {
        return t('taxSentToClientDescription', { ns: 'taskbox' });
      }
      if (createdTask?.status === CreateTaskStatus.REVIEW) {
        return t('taxReviewCreatedDescription', { ns: 'taskbox' });
      }
      if (isEditing) {
        return t('taxSentToClientDescription', { ns: 'taskbox' });
      }
      return t('taxSentToClientDescription', { ns: 'taskbox' });
    }
    if (createdTask?.status === CreateTaskStatus.DRAFT) {
      return t('draftCreatedDescription', { ns: 'taskbox' });
    }
    if (taskDirection === 'SENDING') {
      return t('documentSentDescription', { ns: 'taskbox' });
    }
    if (createdTask?.type === TaskType.SIGN_PAY) {
      return t('documentCreatedDescription', { ns: 'taskbox' });
    }
    return t('signedDocumentCreatedDescription', { ns: 'taskbox' });
  }, [
    binding?.status,
    createdTask?.status,
    createdTask?.type,
    isBinding,
    taskDirection,
    taskType,
  ]);

  return (
    <Finish
      onGetStarted={() => {
        resetForm();
        setPage('E_SIGNATURE');
      }}
      title={title}
      description={description}
      buttonTitle={t('uploadAnotherDocument', { ns: 'taskbox' })}
      onBack={onClose}
      sx={{
        mt: 0,
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    />
  );
};
